<app-control-layout
  [control]="formCtrl"
  [label]="label"
  [ignoreLabel]="ignoreLabel"
  [labelBlock]="labelBlock"
  [labelOpacity]="labelOpacity"
  [width]="width"
  [maxLength]="maxLength"
  [attr.id]="idName"
>
  <div (click)="openModal()" [style.width]="labelBlock ? 'calc(100% - 140px)' : width">
  <input
    type="textbox"
    class="form-control text-box"
    #textInput
    [formControl]="formCtrl"
    [placeholder]="placeHolder"
    [value]="value"
    style="pointer-events: none;width: 100;"
    [attr.id]="idName"
    [ngClass]="{
      'border-danger':
        control?.errors?.required && (control?.touched || externalTrigger)
    }"
    [maxLength]="maxLength"
  />
</div>
</app-control-layout>

<ng-template class="modal-lg" let-modal #taxonomyModal>
  <div class="modal-header d-flex align-items-center ml-3 border-bottom-0">
    <h6 class="modal-title">Taxonomy Look Up</h6>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        fill="currentColor"
        class="bi bi-x"
        viewBox="0 0 16 16"
      >
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 
                          2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
        />
      </svg>
    </button>
  </div>
  <div class="modal-body p-0 mx-3 mb-3">
    <lib-tree-nodes [treeData]="source">
      <ng-template let-item>
        <div class="d-flex align-items-center">
        <span
          style="height: 16px;cursor: pointer;"
          (click)="toggleTreeItem(item)"
          *ngIf="item.children?.length > 0"
        >

          <ng-container *ngIf="item.expanded"><svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-down"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
            />
          </svg></ng-container>
          <ng-container *ngIf="!item.expanded">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-chevron-right"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </ng-container>
        </span>
        <span class="ml-3" style="cursor: pointer;" [ngClass]="{'no-child': !item.children?.length}" (click)="valueSelected(item, true)">
          {{ item.name }}
        </span>
      </div>
      </ng-template>
    </lib-tree-nodes>
  </div>
</ng-template>
